/**
 * Constantes de rutas de la aplicación
 */
export const CommonRoute = {
  HOME: '/',
  LOGIN: '/login',
  RETRY: '/retry',
  APPOINTMENT_MANAGER_DETAIL: '/gestor-citas/detalle',
  REQUESTS: '/gestor-citas/solicitudes',
  REQUIREMENTS: '/gestor-requisitos/solicitudes',
  REQUIREMENTS_DETAIL: '/gestor-requisitos/detalle',
  EVALUATIONS: '/gestor-evaluacion/solicitudes',
  EVALUATIONS_DETAIL: '/gestor-evaluacion/detalle',
  ROLES: '/roles'
} as const;

export type RouteType = typeof CommonRoute[keyof typeof CommonRoute];
